import script from "./MarginCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MarginCard.vue?vue&type=script&setup=true&lang=js"

import "./MarginCard.vue?vue&type=style&index=0&id=1db6ea90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db6ea90"]])

export default __exports__